var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "primary",
    className: "css-zbzjbd e11k6mr30",
    style: {
      minWidth: 40,
      minHeight: 40
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A59",
    d: "M17.215 8.315V5.83a1.914 1.914 0 0 0 1.103-1.726v-.057a1.914 1.914 0 0 0-1.913-1.915h-.057a1.911 1.911 0 0 0-1.912 1.915v.057a1.917 1.917 0 0 0 1.103 1.726v2.486a5.412 5.412 0 0 0-2.575 1.135L6.151 4.14c.049-.176.074-.357.077-.538a2.16 2.16 0 0 0-1.326-1.996 2.152 2.152 0 0 0-2.941 1.568 2.16 2.16 0 0 0 2.11 2.58 2.13 2.13 0 0 0 1.06-.288l6.708 5.225a5.444 5.444 0 0 0 .083 6.126l-2.04 2.043a1.751 1.751 0 0 0-.51-.083 1.768 1.768 0 0 0-1.734 2.118 1.772 1.772 0 0 0 2.412 1.29 1.77 1.77 0 0 0 1.093-1.635 1.752 1.752 0 0 0-.083-.51l2.018-2.021a5.44 5.44 0 0 0 8.753-4.603 5.453 5.453 0 0 0-2.332-4.19 5.437 5.437 0 0 0-2.285-.91Zm-.837 8.178a2.789 2.789 0 0 1-2.648-1.707 2.797 2.797 0 0 1 2.648-3.881 2.79 2.79 0 0 1 2.695 2.792 2.797 2.797 0 0 1-2.692 2.795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/Hubspot.ead3ed074c94eb0d7f6e7230435ad155.svg";
export { ForwardRef as ReactComponent };